/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import React from 'react';

export const useBackgroundColor = (color = '#f8f9fc') => {
  React.useLayoutEffect(() => {
    document.body.style.backgroundColor = color;

    return () => {
      document.body.style.backgroundColor = 'initial';
    };
  }, [color]);
};
